import { Components } from './components.js';
export { Components } from './components.js';
import { Pages } from './pages.js';
export { Pages } from './pages.js';

const selectors = {
  pages: Pages,
  components: Components
};

export { selectors };
//# sourceMappingURL=index.js.map
